<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >设备ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.deviceId"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >设备名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属用户 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.nickname"
                  placeholder="请输入所属用户名称"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属用户ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.userId"
                  placeholder="请输入所属用户ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >手机号码 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="11"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属分组/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.groupId"
                  placeholder="请输入分组名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属网关 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.gatewayName"
                  placeholder="请输入网关名称"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属网关ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.gatewayId"
                  placeholder="请输入网关名称ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >绑定时间 :
              </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
              @click="handleSearch"
              style="margin-bottom: 10px"
              class="marginLeft10"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
              @click="handleReset"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
          </div>
        </div>
      </template>
      <template slot="image" slot-scope="{ row }">
        <el-image
          style="width: 80px; height: 80px"
          :src="row.image"
          :preview-src-list="[row.image]"
        >
        </el-image>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleEdit(row)"
          >设置内部参数</el-button
        >
      </template>
    </avue-crud>
    <el-drawer
      v-if="memberDrawerVisible"
      :title="`设置内部参数`"
      :visible.sync="memberDrawerVisible"
      direction="rtl"
      :before-close="handleMemberClose"
      custom-class="demo-drawer"
      :wrapperClosable="false"
    >
      <div class="box_content">
        <div class="box_item" @click="getType(1)">
          <span>工厂模式</span>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="box_item" @click="getType(2)">
          <span>合闸策略</span>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="box_item" @click="getType(3)">
          <span>单位开关定义</span>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="box_item" @click="getType(4)">
          <span>电流互感器方向</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      v-if="dialogVisible"
      :title="
        `${
          type == 1
            ? '工厂模式'
            : type == 2
            ? '合闸策略'
            : type == 3
            ? '单位开关定义'
            : type == 4
            ? '电流互感器方向'
            : ''
        }`
      "
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="numberValidateForm" :model="form">
        <!-- 工厂模式 -->
        <div v-if="type == 1">
          <el-form-item label="工厂模式口令:">
            <el-input
              v-model="form.factoryCommand"
              style="width: 300px"
              maxlength="4"
            ></el-input>
            <el-button
              class="marginLeft10"
              type="primary"
              :loading="showFactoryCommand"
              :disabled="seconds != 0"
              @click="startCountdown(form)"
              >确认</el-button
            >
          </el-form-item>
          <el-form-item label="内置配置控制指令:">
            <el-input
              v-model="form.internalCommand"
              style="width: 300px"
              maxlength="4"
              :disabled="seconds == 0"
            ></el-input>
            <span class="marginLeft10">{{ seconds ? seconds + "s" : "" }}</span>
          </el-form-item>
        </div>
        <!-- 合闸策略 -->
        <div v-if="type == 2">
          <el-form-item label="手动分闸/故障跳闸远程合闸:">
            <el-radio-group v-model="form.handCloseStrategy" size="mini">
              <el-radio label="0">允许</el-radio>
              <el-radio label="1">禁止</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="本地模式定时合闸、重合闸:">
            <el-radio-group v-model="form.localCloseStrategy" size="mini">
              <el-radio label="0">允许</el-radio>
              <el-radio label="1">禁止</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 单位开关定义 -->
        <div v-if="type == 3">
          <el-form-item label="电能量单位:">
            <el-radio-group v-model="form.electricEnergyUnit" size="mini">
              <el-radio label="0">1kWh</el-radio>
              <el-radio label="1">0.1kWh</el-radio>
              <el-radio label="2">0.01kWh</el-radio>
              <el-radio label="3">0.001kWh</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="功率量单位:">
            <el-radio-group v-model="form.powerUnit" size="mini">
              <el-radio label="0">1kW</el-radio>
              <el-radio label="1">0.1kW</el-radio>
              <el-radio label="2">0.01kW</el-radio>
              <el-radio label="3">0.001kW(1W)</el-radio>
              <el-radio label="4">0.0001kW(0.1W)</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="电流量单位:">
            <el-radio-group v-model="form.currentQuantityUnit" size="mini">
              <el-radio label="0">1A</el-radio>
              <el-radio label="1">0.1A</el-radio>
              <el-radio label="2">0.01A</el-radio>
              <el-radio label="3">0.001A(1mA)</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- 电流互感器方向 -->
        <div v-if="type == 4">
          <div>电流互感器方向</div>
          <el-form-item label="A相:">
            <el-radio-group v-model="form.aphase" size="mini">
              <el-radio label="0">正向</el-radio>
              <el-radio label="1">反向</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="B相:">
            <el-radio-group v-model="form.bphase" size="mini">
              <el-radio label="0">正向</el-radio>
              <el-radio label="1">反向</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="C相:">
            <el-radio-group v-model="form.cphase" size="mini">
              <el-radio label="0">正向</el-radio>
              <el-radio label="1">反向</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
      <div style="text-align: center">
        <el-button class="marginLeft10" type="" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          class="marginLeft10"
          type="primary"
          :loading="showLoadingForm"
          @click="submit(form)"
          :disabled="type == 1 && seconds == 0"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  manageList,
  updateFactoryCommand,
  updateInternalCommand,
  updateCloseStrategy,
  updateUnitSwitch,
  updateTransformer,
  manageView,
} from "@/api/device/manage";
import dayjs from "dayjs";
import { EClosing, MClosing, OClosing } from "@/enums/beCurrent/EBeCurrent";

export default {
  name: "index",
  data() {
    return {
      EClosing: EClosing,
      MClosing: MClosing,
      OClosing: OClosing,
      searchData: {
        title: "",
        createTime: "",
        userId: this.$route.query.id || "",
        gatewayId: this.$route.query.gatewayId || "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "设备ID",
            prop: "deviceId",
          },
          {
            label: "设备名称",
            prop: "name",
          },
          {
            label: "设备图片",
            prop: "image",
          },
          {
            label: "所属用户",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属分组",
            prop: "groupName",
          },
          {
            label: "所属网关",
            prop: "gatewayName",
          },
          {
            label: "绑定时间",
            prop: "bindTime",
          },
        ],
      },
      memberDrawerVisible: false,
      dialogVisible: false,
      form: {
        handCloseStrategy: "0",
        localCloseStrategy: "0",
        currentQuantityUnit: "0",
        electricEnergyUnit: "0",
        powerUnit: "0",
        aphase: "0",
        bphase: "0",
        cphase: "0",
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [
          {
            label: "用户昵称",
            prop: "nickname",
            // type: "text",
            maxlength: 8,
            span: 16,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "邮箱",
            prop: "email",
            maxlength: 100,
            span: 16,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入邮箱",
                trigger: "blur",
              },
            ],
          },
          {
            label: "密码",
            prop: "password",
            maxlength: 20,
            span: 16,
            type: "password",
            // showWordLimit: true,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入密码",
                trigger: "blur",
              },
              {
                validator(_, value) {
                  if (value) {
                    if (value.length < 6) {
                      return Promise.reject(new Error("最少6位"));
                    }
                  }
                  return Promise.resolve(true);
                },
              },
            ],
          },
        ],
      },
      type: "", //设置内部参数 1工厂模式 2合闸策略 3单位开关定义 4电流互感器方向
      seconds: 0,
      timer: null,
      id: "",
      showFactoryCommand: false,
      viewList: {}, //设置内部参数详情
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.bindTimeStart = dayjs(this.searchData.createTime[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        searchData.bindTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      manageList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        state: "",
        name: "",
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    // 提交
    submit(form) {
      this.$refs["numberValidateForm"].validate((valid) => {
        if (valid) {
          if (this.showLoadingForm) {
            return;
          }
          this.showLoadingForm = true;
          if (this.type == 1) {
            this.submitOne();
          } else if (this.type == 2) {
            this.submitTwo();
          } else if (this.type == 3) {
            this.submitThree();
          } else if (this.type == 4) {
            this.submitFour();
          }
        }
      });
    },
    //工厂模式提交
    submitOne() {
      updateInternalCommand({
        id: this.id,
        internalCommand: this.form.internalCommand,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
            setTimeout(() => {
              this.resetForm();
            }, 500);
            this.onLoad();
            this.showLoadingForm = false;
          } else {
            // this.$message.error(res.msg);
            this.showLoadingForm = false;
            done();
          }
        })
        .catch(() => (this.showLoadingForm = false));
    },
    //合闸策略
    submitTwo() {
      updateCloseStrategy({
        id: this.id,
        handCloseStrategy: this.form.handCloseStrategy,
        localCloseStrategy: this.form.localCloseStrategy,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
            setTimeout(() => {
              this.resetForm();
            }, 500);
            this.onLoad();
            setTimeout(() => {
              this.getManageView(this.id);
            }, 10000);
            this.showLoadingForm = false;
          } else {
            // this.$message.error(res.msg);
            this.showLoadingForm = false;
            done();
          }
        })
        .catch(() => (this.showLoadingForm = false));
    },
    //单位开关定义
    submitThree() {
      updateUnitSwitch({
        id: this.id,
        currentQuantityUnit: this.form.currentQuantityUnit,
        electricEnergyUnit: this.form.electricEnergyUnit,
        powerUnit: this.form.powerUnit,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
            setTimeout(() => {
              this.resetForm();
            }, 500);
            this.onLoad();
            setTimeout(() => {
              this.getManageView(this.id);
            }, 5000);
            this.showLo;
            this.showLoadingForm = false;
          } else {
            // this.$message.error(res.msg);
            this.showLoadingForm = false;
            done();
          }
        })
        .catch(() => (this.showLoadingForm = false));
    },
    //电流互感器方向
    submitFour() {
      updateTransformer({
        id: this.id,
        aphase: this.form.aphase,
        bphase: this.form.bphase,
        cphase: this.form.cphase,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.dialogVisible = false;
            setTimeout(() => {
              this.resetForm();
            }, 500);
            this.onLoad();
            setTimeout(() => {
              this.getManageView(this.id);
            }, 5000);
            this.showLo;
            this.showLoadingForm = false;
          } else {
            // this.$message.error(res.msg);
            this.showLoadingForm = false;
            done();
          }
        })
        .catch(() => (this.showLoadingForm = false));
    },
    handleMemberClose() {
      this.memberDrawerVisible = false;
    },
    //设置内部参数
    async handleEdit(row) {
      await this.getManageView(row.id);
      this.memberDrawerVisible = true;
      this.id = row.id;
    },
    //获取内部参数
    getManageView(id) {
      manageView(id).then((res) => {
        if (res.code == 200) {
          this.viewList = res.data;
        }
      });
    },
    //打开对应设置的内部参数
    getType(e) {
      this.type = e;
      this.form.handCloseStrategy = this.viewList.handCloseStrategy;
      this.form.localCloseStrategy = this.viewList.localCloseStrategy;

      this.form.currentQuantityUnit = this.viewList.currentQuantityUnit;
      this.form.electricEnergyUnit = this.viewList.electricEnergyUnit;
      this.form.powerUnit = this.viewList.powerUnit;

      this.form.aphase = this.viewList.APhase;
      this.form.bphase = this.viewList.BPhase;
      this.form.cphase = this.viewList.CPhase;

      this.dialogVisible = true;
    },
    //发送指令 60s倒计时
    startCountdown() {
      if (!this.form.factoryCommand) {
        this.$message.error("请先输入工厂模式口令");
        return;
      }
      if (this.showFactoryCommand) {
        return;
      }
      this.showFactoryCommand = true;
      updateFactoryCommand({
        id: this.id,
        factoryCommand: this.form.factoryCommand,
      })
        .then((res) => {
          if (res.code == 200) {
            this.seconds = 60;
            this.timer = setInterval(() => {
              if (this.seconds > 0) {
                this.seconds--;
              } else {
                clearInterval(this.timer);
                this.seconds = 0;
              }
            }, 1000);
          }
        })
        .finally(() => {
          this.showFactoryCommand = false;
        });
    },
    //关闭
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
.box_content {
  padding: 0 30px;
}
.box_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 30px;
  cursor: pointer;
}
</style>
